import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import { HTTPResponse } from '@/services/http/http.types'
import { IAdminUser, ILoginResponse } from './auth.types'

const login = (dto: { login: string; password: string }): Promise<HTTPResponse<ILoginResponse>> => {
  return http.post('/v1/auth/login', dto).then(handleHttpResponse).catch(handleHttpError)
}

const getSelf = (): Promise<HTTPResponse<IAdminUser>> => {
  return http.get('/v1/self').then(handleHttpResponse).catch(handleHttpError)
}

const authApi = { login, getSelf }
export default authApi
